import * as React from 'react';
import Navbar from './Navbar';

interface IHeaderProps {
  showNavbar?: boolean;
}

export default function Header(props: IHeaderProps) {
  const { showNavbar = true } = props;

  return (
    <header className="container-fluid header">
      <div className="row">
        <div className="col-12 col-md-3 justify-content-center align-items-center header--inner d-flex">
          <a href="https://www.falabella.com.mx" target="_blank" rel="noopener noreferrer">
            <img src="//sfestaticos.blob.core.windows.net/guideline/logos/logo-falabella-soriana.svg" alt="Logo Seguros Falabella" width="180px" />
          </a>
        </div>
        {showNavbar && <Navbar />}
      </div>
    </header>
  );
}
